var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLumReady(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66675 20C5.06675 20 4.66675 19.5 4.66675 19V18H10.6667V19C10.6667 19.5 10.2667 20 9.66675 20H5.66675ZM0.666748 7C0.666748 3.1 3.76675 0 7.66675 0C11.5667 0 14.6667 3.1 14.6667 7C14.6667 9.3 13.4667 11.4 11.6667 12.7V15C11.6667 15.5 11.2667 16 10.6667 16H4.66675C4.06675 16 3.66675 15.5 3.66675 15V12.7C1.86675 11.5 0.666748 9.4 0.666748 7ZM3.88745 8.53L6.71745 11.36L11.6675 6.41L10.2575 5L6.70745 8.53L5.29745 7.12L3.88745 8.53Z",
    fill: "#39B620"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumReady);
export default __webpack_public_path__ + "static/media/lumReady.adcc346f5ef4ae44edd7350c60095aec.svg";
export { ForwardRef as ReactComponent };